// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"75":"489cb8ea","693":"8a1be7d9"}[chunkId] + ".chunk.css";
};